import { combineReducers } from "redux";
import global from "./global/reducers";
import auth from "./auth/reducers";
import employer from './employer/reducers';

export default combineReducers({ global, auth, employer });
